import type { VideoEmbedBlock } from '@atlas/renderer';

export default function extractVideoEmbedBlockFromIframeElement(iframe: HTMLIFrameElement): VideoEmbedBlock | null {
    const youtubeResourceId = iframe.src.match(/^https:\/\/www\.youtube\.com\/embed\/([-_a-z\d]+)/i)?.[1];
    if (youtubeResourceId) {
        return {
            type: 'video-embed',
            service: 'youtube',
            resourceId: youtubeResourceId,
            alt: iframe.title,
            children: [{ text: '' }],
        };
    }

    const vimeoResourceId = iframe.src.match(/^https:\/\/player\.vimeo\.com\/video\/\d+/i)?.[1];
    if (vimeoResourceId) {
        return {
            type: 'video-embed',
            service: 'vimeo',
            resourceId: vimeoResourceId,
            alt: iframe.title,
            children: [{ text: '' }],
        };
    }

    const loomResourceId = iframe.src.match(/^https:\/\/www\.loom\.com\/embed\/([_a-z\d]+)/i)?.[1];
    if (loomResourceId) {
        return {
            type: 'video-embed',
            service: 'loom',
            resourceId: loomResourceId,
            alt: iframe.title,
            children: [{ text: '' }],
        };
    }

    const cluesoEmbedMatch = iframe.src.match(/^https:\/\/([\w-]+)\.clueso\.io\/embed\/([a-z\d-]+)(\?|$)/i);
    if (cluesoEmbedMatch?.[1] && cluesoEmbedMatch?.[2]) {
        return {
            type: 'video-embed',
            service: 'clueso',
            cluesoSubdomain: cluesoEmbedMatch[1],
            resourceId: cluesoEmbedMatch[2],
            children: [{ text: '' }],
        };
    }

    return null;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('extractVideoEmbedBlockFromIframeElement', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
